import FirestoreCollectionStore from '../../../modules/vuex-firestore/FirestoreCollectionStore'

const state = {}

const mutations = {}

const getters = {}

const actions = {
  addImage({ state, dispatch }, { value }) {
    return dispatch('$create', { imageKey: value })
  },
  setPos({ state }, { key, data }) {
    return state.$collection.doc(key).set({
      x: data.x,
      y: data.y,
      w: data.w,
      h: data.h,
      angle: data.angle,
      timestamp: state.$timestamp()
    }, { merge: true })
  },
  setPin({ state }, { key, data }) {
    return state.$collection.doc(key).set({
      pinnedInScene: data.pinnedInScene,
      timestamp: state.$timestamp()
    }, { merge: true })
  }
}

function formatter({ imageKey, x = 0, y = 0, w = null, h = null, angle = 0, pinnedInScene = false, timestamp }) {
  return {
    imageKey,
    x,
    y,
    z: 0,
    w,
    h,
    angle,
    pinnedInScene,
    timestamp
  }
}

export default new FirestoreCollectionStore({
  $name: 'imageObjectList',
  $formatter: formatter,
  state,
  mutations,
  getters,
  actions
})
